import ProfileTabsv2 from './ProfileTabsv2/ProfileTabsv2'


function Profile(props){
return (
    <>
        <ProfileTabsv2 />
    </>
    )
}

export default Profile
